import CalendarPanel from './calendar-panel';

export default CalendarPanel;
